export default "__VITE_ASSET__55f58fdf__"